export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/homefillSvg.bf856b6c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};